import { c as _c } from "react/compiler-runtime";
import { renderStructuredContent } from '../../renderContext';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../types';
export type ListProps = StructuredContentDocumentWithRenderer<{
  ordered?: boolean;
  children: StructuredContentDocument;
}>;
export const List = t0 => {
  const $ = _c(5);
  const {
    props
  } = t0;
  const Component = props.ordered ? "ol" : "ul";
  let t1;
  if ($[0] !== props.children) {
    t1 = renderStructuredContent(props.children);
    $[0] = props.children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== Component || $[3] !== t1) {
    t2 = <Component>{t1}</Component>;
    $[2] = Component;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};